import { z } from 'zod';
// "Mi perfil".
//
// Campos auto-editables por el propio usuario: SOLO `nombre` (+ foto, que va por
// endpoint multipart aparte). email / rol / área / activo siguen siendo
// ADMIN-only (no se aceptan acá). La contraseña conserva su flujo propio
// (/auth/cambiar-password).
// Mismas reglas que el `nombre` del admin (usuarioActualizarSchema).
export const perfilActualizarSchema = z.object({
    nombre: z.string().min(2).max(120),
});
// Avatar — whitelist de imágenes + tope de 2 MB (validado server-side por
// tamaño + magic bytes).
export const AVATAR_MIME_PERMITIDOS = ['image/jpeg', 'image/png', 'image/webp'];
export const AVATAR_TAMANIO_MAX_BYTES = 2 * 1024 * 1024; // 2 MB
//# sourceMappingURL=perfil.js.map